import { useQuery } from "react-query";
import Select from "react-select";

import { getCompanies } from "../../../../../MyApi/hr/companies";

import icons from "../../../../../Data/icons";
import classes from "./addRequest.module.css";

const AddRequest = ({
  setRequestName,
  setDescription,
  setImageFile,
  setSlug,
  setType,
  loan,
  setLoan,
  setActive,
  active,
  setCompanyId,
  requestName,
  description,
  slug,
  type,
  fileInputRef,
}) => {
  const { data } = useQuery("getCompaines", getCompanies);

  const Image = icons.image;
  const Ab = icons.name;

  const compaines = data?.data || [];
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const role = user.role;

  const types = [
    { id: 1, label: "datefrom" },
    { id: 2, label: "date to" },
    { id: 3, label: "time from" },
    { id: 4, label: "time to" },
    { id: 5, label: "image" },
    { id: 6, label: "amount" },
  ];

  const handleNameChange = (e) => {
    setRequestName(e.target.value);
  };
  const handleDescription = (e) => {
    setDescription(e.target.value);
  };
  const handleImage = (e) => {
    setImageFile(e.target.files[0]);

  };
  const handleSlug = (e) => {
    setSlug(e.target.value);
  };
  const handleCheckBoxChange = (e) => {
    const isChecked = e.target.checked;
    const checkedId = e.target.id;

    setType((prevCheckedIds) => {
      if (isChecked) {
        return [...prevCheckedIds, +checkedId];
      } else {
        return prevCheckedIds.filter((id) => id !== +checkedId);
      }
    });
  };
  const handleLoan = (e) => {
    const isChecked = e.target.checked;
    setLoan(isChecked ? 1 : 0);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };
  const handleComapnyId = (selectedOption) => {
    const companyId = selectedOption ? selectedOption.id : null;
    setCompanyId(companyId);
  };

  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الطلب</label>
          <div className={classes.iconInput}>
            <Ab />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم الطلب"
            value={requestName}
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الوصف</label>
          <div className={classes.iconInput}>
            <Ab />
          </div>
          <textarea
            type="text"
            placeholder="ادخل الوصف "
            value={description}
            onChange={handleDescription}
            className={classes.inputCustom}>
            {" "}
          </textarea>
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الصورة</label>
          <div className={classes.iconInput}>
            <Image />
          </div>
          <input
            type="file"
            accept="jpeg,png"
            placeholder="ادخل الصورة "
            onChange={handleImage}
            ref={fileInputRef}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الاسم المستعار</label>
          <div className={classes.iconInput}>
            <Ab />
          </div>
          <input
            type="text"
            placeholder="ادخل الاسم المستعار "
            value={slug}
            onChange={handleSlug}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> النوع</label>

          <fieldset>
            {types.map((requesttype) => (
              <div className={classes.checkInput} key={requesttype.id}>
                <input
                  type="checkbox"
                  id={requesttype.id}
                  onChange={handleCheckBoxChange}
                  className={classes.checkBoxCustom}
                  checked={type.find((id) => id === requesttype.id)}
                />
                <label htmlFor="dateFrom">{requesttype.label}</label>
              </div>
            ))}
          </fieldset>
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor=""
            className={loan ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {loan === 1 ? "اقتراض" : "لايوجد اقتراض"}{" "}
          </label>

          <label class="switch">
            <input type="checkbox" onChange={handleLoan} checked={loan} />
            <span class="slider round"></span>
          </label>
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor=""
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {active === 1 ? " نشط" : "غير نشط"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>
        {role === "system_adminstrator" && (
          <div className={classes.formCol}>
            <label htmlFor=""> اختار الشركة</label>
            {!data ? (
              <div> no data avalible </div>
            ) : (
              <Select
                type="text"
                options={compaines}
                getOptionValue={(e) => e.id}
                getOptionLabel={(e) => e.name}
                isClearable={true}
                placeholder=" الرمز التعريفي للشركة"
                onChange={handleComapnyId}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddRequest;
